import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { ReactiveFormsModule } from '@angular/forms';

import { HasPermissionDirective } from '../directive/has-permission.directive';
import { SafeHtmlPipe } from './../pipe/safe-html.pipe';
import { TableReflowDirective } from '../directives/table-reflow.directive';
import { LoaderComponent } from './loader/loader.component';
import { CustomValidation } from '../helpers/customValidation';

@NgModule({
  declarations: [
    HasPermissionDirective,
    SafeHtmlPipe,
    TableReflowDirective,
    LoaderComponent
  ],
  imports: [
    CommonModule,
    NgSelectModule,
    ReactiveFormsModule
  ],
  providers: [
    CustomValidation
  ],
  exports: [
    CommonModule,
    NgSelectModule,
    ReactiveFormsModule,
    HasPermissionDirective,
    SafeHtmlPipe,
    TableReflowDirective,
    LoaderComponent
  ]
})
export class SharedModule { }
